import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class WorksQualityNormsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS_QUALITY_NORMS, {
			entity: 'works_quality_norms',
		})
	}
}
